// extracted by mini-css-extract-plugin
export default {"svg":"Svg_svg__jm0EI"};